import { Row } from '@tanstack/react-table'

import { Log, UpdatedRecordsType } from '@/types/logs'
import { LogAction } from './LogAction'
import { markUpdatedRecords } from '@/pages/UnfinishedRecords/helpers/markUpdatedRecords'
import { UPDATED_RECORDS_LABEL_MAP } from '@/pages/UnfinishedRecords/constant'

import styles from './LogAction.module.scss'

import ChatIcon from '../../../assets/chat.svg'

interface Props {
    row: Row<Log>
}

export const ReaderLogAction = ({ row }: Props) => {
    const [log] = markUpdatedRecords([row.original])

    return (
        <LogAction log={log} shouldDisplayCompleteRecord={false}>
            {log.unfinishedType ? (
                <div className={styles.updatedTypeContainer}>
                    {UPDATED_RECORDS_LABEL_MAP[log.unfinishedType]}
                    {log.unfinishedType === UpdatedRecordsType.Flagged && <ChatIcon />}
                </div>
            ) : null}
        </LogAction>
    )
}
